document.addEventListener("DOMContentLoaded", function () {
  const members = document.querySelectorAll(".household-member");
  const button = document.getElementById("add-household-member");

  if (!members.length || !button) return;

  let visibleCount = 1;

  members.forEach(function (member, index) {
    member.style.display = index === 0 ? "" : "none";
  });

  button.addEventListener("click", function () {
    if (visibleCount < 10) {
      members[visibleCount].style.display = "";
      visibleCount++;
    }

    if (visibleCount >= 10) {
      button.style.display = "none";
    }
  });
});
